<div class="page-container">
  <div class="page-title-section">
    <h1><mat-icon>people</mat-icon> Usuários</h1>
    <p class="page-subtitle">Gerencie os usuários cadastrados no sistema</p>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-5">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Nome</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>E-mail</mat-label>
          <input matInput type="text" formControlName="email" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Empresa</mat-label>
          <mat-select placeholder="Selecione a empresa" formControlName="userType">
            <mat-option value="">Todas</mat-option>
            <mat-option value="MICHELIN">Michelin</mat-option>
            <mat-option value="AUTOMAKER">Montadora (OE)</mat-option>
            <mat-option value="DEALERSHIP">Concessionaria (CC)</mat-option>
            <mat-option value="DISTRIBUTOR">Dist. Exclusivo (DE)</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Nome Fantasia</mat-label>
          <input matInput type="text" formControlName="companyName" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select placeholder="Selecione o status" formControlName="enabled">
            <mat-option value="">Todos</mat-option>
            <mat-option value="true">Ativos</mat-option>
            <mat-option value="false">Inativos</mat-option>
          </mat-select>
        </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar</span>
        </button>
      </div>
      <div class="filter-footer-right">
        <button mat-flat-button color="primary" class="mic-btn-icon-left" routerLink="/users/create">
          <mat-icon>add_circle</mat-icon><span>Cadastrar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micCellTemplate="let item; name: 'activeCell'">
        @if (item.enabled) {
          <mat-icon>check</mat-icon>
        }
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'actionsCell'">
        <button mat-icon-button color="primary" (click)="redirectToEdit(item)">
          <mat-icon>edit_square</mat-icon>
        </button>
      </ng-container>
    </mic-table>
  </div>
</div>
